import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";


export async function getTicketKpis() {
  try {
    const data = await authenticatedFetch(URL.getKpis);
    return data;
  } catch (error) {
    console.error("Error fetching tickets KPI details:", error);
    throw error;
  }
}
